// ============================================================
// VCS.ChatGroups — Gruppenchats
// - Gruppe erstellen, umbenennen, Bild aendern
// - Mitglieder hinzufuegen / entfernen
// - Admin-Verwaltung, Gruppe verlassen / loeschen
// - Gruppen-Info-View, Mitglieder-Liste
// - Sub-Tabs (Medien, Dateien, Links)
// ============================================================
window.VCS = window.VCS || {};

VCS.ChatGroups = class {

    constructor() {
        this._view = {};
        this._activeGroupId = null;
        // Gruppeneinladungen (28.09.): Warteschlange, damit mehrere
        // Einladungen nacheinander kommen und nie zwei Dialoge gleichzeitig.
        this._inviteQueue = [];
        this._inviteDialogOpen = false;
        // "Spaeter" gilt bis zum naechsten Oeffnen der App -- nur im Speicher,
        // sonst kaeme der Dialog bei jedem Reconnect (chat-auth-Replay) wieder.
        this._invitesLater = new Set();
    }

    // ── Gruppen laden & rendern ─────────────────────────────

    async loadGroups() {
        try {
            const res = await fetch(VCS.Chat.API_BASE + '/groups', {
                headers: VCS.chat?.authHeaders()
            });
            if (!res.ok) return;
            VCS.state.chatGroups = await res.json();
            this.renderGroupList();
        } catch (e) {
            console.error('[groups] loadGroups error:', e);
        }
    }

    renderGroupList() {
        const container = $('#groupsList')[0];
        if (!container) return;
        const groups = VCS.state.chatGroups;
        const t = (k) => VCS.i18n?.t(k) || k;

        if (!groups || groups.length === 0) {
            container.innerHTML = `<div class="chat-list-empty"><span>${t('groupsEmpty')}</span></div>`;
            return;
        }

        let html = '';
        for (const g of groups) {
            const initial = (g.name || '?').charAt(0).toUpperCase();
            const avatarContent = g.avatarHash
                ? `<img src="${VCS.Chat.API_BASE}/groups/${g.id}/avatar/${g.avatarHash}" alt="">`
                : initial;
            const memberText = t('groupMemberCount').replace('{0}', g.memberCount || 0);

            html += `<div class="chat-list-item d-flex align-items-center gap-3" data-group-id="${g.id}">
                <div class="group-list-avatar">${avatarContent}</div>
                <div class="flex-grow-1 min-w-0">
                    <div class="chat-list-name">${this._esc(g.name)}</div>
                    <div class="chat-list-preview group-member-count">${memberText}</div>
                </div>
                <button class="group-edit-btn" data-group-id="${g.id}" title="${t('groupSettings')}">
                    <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="3"></circle>
                        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
                    </svg>
                </button>
            </div>`;
        }

        container.innerHTML = html;

        container.querySelectorAll('.chat-list-item').forEach(item => {
            item.addEventListener('click', (e) => {
                if (e.target.closest('.group-edit-btn')) return;
                const groupId = item.dataset.groupId;
                if (groupId) this.openGroupChat(groupId);
            });
        });

        container.querySelectorAll('.group-edit-btn').forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.stopPropagation();
                const groupId = btn.dataset.groupId;
                if (groupId) this.openGroupDetail(groupId);
            });
        });
    }

    openGroupChat(groupId) {
        const group = (VCS.state.chatGroups || []).find(g => g.id === groupId);
        const name = group?.name || '?';
        // Sicherstellen dass die Gruppe in chatChats existiert
        let chat = VCS.state.chatChats.find(c => c.id === groupId);
        if (!chat) {
            chat = { id: groupId, name, isGroup: true, _isGroup: true, _peerName: name, _peerAvatarHash: group?.avatarHash || null, created_at: group?.created_at || Date.now() };
            VCS.state.chatChats.push(chat);
        }
        VCS.nav?.showAppShell('tabChats');
        VCS.chatSetup?.openConversation(groupId, null, name);
    }

    // ── Gruppe erstellen ────────────────────────────────────

    showCreateGroupModal() {
        const picker = $('#newGroupContactPicker')[0];
        const nameInput = $('#newGroupNameInput')[0];
        if (!picker || !nameInput) return;

        nameInput.value = '';
        const contacts = VCS.state.chatMergedContacts || VCS.state.chatSavedContacts || [];

        if (contacts.length === 0) {
            const t = (k) => VCS.i18n?.t(k) || k;
            picker.innerHTML = `<div class="text-muted small">${t('groupNoContacts')}</div>`;
        } else {
            let html = '';
            for (const c of contacts) {
                const name = c.displayName || c.phoneNumber;
                html += `<label class="group-contact-picker-item">
                    <input type="checkbox" value="${this._esc(c.phoneNumber)}">
                    <span>${this._esc(name)}</span>
                </label>`;
            }
            picker.innerHTML = html;
        }

        const modal = new bootstrap.Modal($('#newGroupModal')[0]);
        modal.show();
    }

    async createGroup() {
        const nameInput = $('#newGroupNameInput')[0];
        const name = nameInput?.value?.trim();
        const t = (k) => VCS.i18n?.t(k) || k;

        if (!name) {
            alert(t('groupNameRequired'));
            return;
        }

        const picker = $('#newGroupContactPicker')[0];
        const phones = [];
        picker?.querySelectorAll('input[type="checkbox"]:checked').forEach(cb => {
            phones.push(cb.value);
        });

        try {
            const res = await fetch(VCS.Chat.API_BASE + '/groups', {
                method: 'POST',
                headers: VCS.chat?.authHeaders({ 'Content-Type': 'application/json' }),
                body: JSON.stringify({ name, members: phones })
            });
            if (!res.ok) return;

            bootstrap.Modal.getInstance($('#newGroupModal')[0])?.hide();
            // Seit 28.09. werden die Ausgewaehlten eingeladen, nicht eingetragen --
            // sonst wundert sich der Ersteller, warum die Gruppe leer ist.
            if (phones.length > 0) VCS.ui?.showToast?.(t('groupInvitesSent'), 'success', 5000);
            await this.loadGroups();
        } catch (e) {
            console.error('[groups] createGroup error:', e);
        }
    }

    // ── Gruppen-Detail ──────────────────────────────────────

    async openGroupDetail(groupId) {
        try {
            const res = await fetch(VCS.Chat.API_BASE + '/groups/' + groupId, {
                headers: VCS.chat?.authHeaders()
            });
            if (!res.ok) return;
            const data = await res.json();
            this._activeGroupId = groupId;
            this._renderGroupDetail(data);
        } catch (e) {
            console.error('[groups] openGroupDetail error:', e);
        }
    }

    _renderGroupDetail(data) {
        const screen = $('#groupDetailScreen')[0];
        if (!screen) return;

        const t = (k) => VCS.i18n?.t(k) || k;
        const myPhone = VCS.state.chatMyPhone;
        const myMember = data.members?.find(m => m.phone === myPhone);
        const isAdmin = myMember?.role === 'admin';

        // Header + Avatar
        const initial = (data.name || '?').charAt(0).toUpperCase();
        const avatarEl = $('#groupDetailAvatar')[0];
        if (data.avatarHash) {
            avatarEl.innerHTML = `<img src="${VCS.Chat.API_BASE}/groups/${data.id}/avatar/${data.avatarHash}" alt="">`;
            avatarEl.classList.add('has-avatar');
        } else {
            avatarEl.innerHTML = '';
            avatarEl.textContent = initial;
            avatarEl.classList.remove('has-avatar');
        }
        $('#groupDetailName')[0].textContent = data.name || '';
        $('#groupDetailMemberCount')[0].textContent = `(${data.members?.length || 0})`;

        // Avatar-Edit-Button nur für Admin
        const avatarEdit = $('#groupDetailAvatarEdit')[0];
        if (avatarEdit) avatarEdit.classList.toggle('hidden', !isAdmin);

        // Buttons je nach Rolle
        const btnDelete = $('#btnGroupDelete')[0];
        const btnRename = $('#btnGroupRename')[0];
        const btnAddMember = $('#btnGroupAddMember')[0];
        if (btnDelete) btnDelete.classList.toggle('hidden', !isAdmin);
        if (btnRename) btnRename.classList.toggle('hidden', !isAdmin);
        if (btnAddMember) btnAddMember.classList.toggle('hidden', false);

        // Mitgliederliste
        const list = $('#groupMembersList')[0];
        if (list) {
            let html = '';
            for (const m of (data.members || [])) {
                const name = m.displayName || m.phone;
                const onlineClass = m.online ? ' group-member-name-online' : '';
                const badge = m.role === 'admin' ? `<span class="group-role-badge">${t('groupAdmin')}</span>` : '';
                const removeBtn = (isAdmin && m.phone !== myPhone)
                    ? `<button class="group-member-remove-btn" data-phone="${this._esc(m.phone)}" title="${t('groupMemberRemoved')}">&times;</button>`
                    : '';

                const av = VCS.chat?.avatarHtml?.((name || '?').charAt(0).toUpperCase(), m.avatarHash, 'group-member-avatar') || { html: (name || '?').charAt(0).toUpperCase(), hasAvatar: false };

                html += `<div class="chat-list-item d-flex align-items-center gap-3" data-phone="${this._esc(m.phone)}">
                    <div class="chat-list-avatar${av.hasAvatar ? ' has-avatar' : ''}">${av.html}</div>
                    <div class="flex-grow-1 min-w-0">
                        <span class="chat-list-name${onlineClass}">${this._esc(name)}</span>${badge}
                    </div>
                    ${removeBtn}
                </div>`;
            }

            // Offene Einladungen (28.09.): unter den Mitgliedern, als
            // "eingeladen" markiert. Zurueckziehen darf, wer eingeladen hat,
            // und jeder Admin (Server prueft das erneut).
            for (const inv of (data.invites || [])) {
                const name = inv.displayName || inv.phone;
                const mayWithdraw = isAdmin || inv.invitedBy === myPhone;
                const withdrawBtn = mayWithdraw
                    ? `<button class="group-member-remove-btn group-invite-withdraw-btn" data-phone="${this._esc(inv.phone)}" title="${t('groupInviteWithdraw')}">&times;</button>`
                    : '';
                const av = VCS.chat?.avatarHtml?.((name || '?').charAt(0).toUpperCase(), inv.avatarHash, 'group-member-avatar') || { html: (name || '?').charAt(0).toUpperCase(), hasAvatar: false };
                html += `<div class="chat-list-item d-flex align-items-center gap-3 group-member--invited" data-phone="${this._esc(inv.phone)}">
                    <div class="chat-list-avatar${av.hasAvatar ? ' has-avatar' : ''}">${av.html}</div>
                    <div class="flex-grow-1 min-w-0">
                        <span class="chat-list-name">${this._esc(name)}</span><span class="group-role-badge group-role-badge--invited">${t('groupInvited')}</span>
                    </div>
                    ${withdrawBtn}
                </div>`;
            }
            list.innerHTML = html;

            // Remove-Buttons
            list.querySelectorAll('.group-member-remove-btn:not(.group-invite-withdraw-btn)').forEach(btn => {
                btn.addEventListener('click', (e) => {
                    e.stopPropagation();
                    this.removeMember(this._activeGroupId, btn.dataset.phone);
                });
            });
            list.querySelectorAll('.group-invite-withdraw-btn').forEach(btn => {
                btn.addEventListener('click', (e) => {
                    e.stopPropagation();
                    this.withdrawInvite(this._activeGroupId, btn.dataset.phone);
                });
            });
        }

        // Screens umschalten
        $('#tabContacts')[0]?.classList.add('hidden');
        $('#bottomNav')[0]?.classList.add('hidden');
        screen.classList.remove('hidden');
    }

    closeGroupDetail() {
        $('#groupDetailScreen')[0]?.classList.add('hidden');
        $('#tabContacts')[0]?.classList.remove('hidden');
        $('#bottomNav')[0]?.classList.remove('hidden');
        this._activeGroupId = null;
    }

    // ── Mitglieder hinzufügen ───────────────────────────────

    async showAddMemberModal() {
        if (!this._activeGroupId) return;
        const picker = $('#addMemberContactPicker')[0];
        if (!picker) return;

        const t = (k) => VCS.i18n?.t(k) || k;

        // Modal früh anzeigen mit Loading-State, damit der User Feedback
        // bekommt während wir die frischen Daten holen.
        picker.innerHTML = `<div class="text-muted small">${t('loading') || '...'}</div>`;
        const modal = new bootstrap.Modal($('#addGroupMemberModal')[0]);
        modal.show();

        // Kontakte: Wenn mergedContacts noch nicht aufgebaut ist, laden. Der
        // klassische `A || B`-Fallback greift nicht, weil ein leerer Array in
        // JS truthy ist → chatMergedContacts gewinnt immer, auch wenn leer.
        let contacts = VCS.state.chatMergedContacts || [];
        if (contacts.length === 0) {
            try {
                await VCS.chatContacts?.loadContacts?.();
                contacts = VCS.state.chatMergedContacts || [];
            } catch (e) {
                console.error('[groups] loadContacts error:', e);
            }
        }
        if (contacts.length === 0) {
            contacts = VCS.state.chatSavedContacts || [];
        }

        // Aktuelle Mitglieder: direkt vom Server — der DOM-Scan war flaky,
        // weil die Member-Liste nach `openGroupDetail` asynchron gerendert
        // wird. Frisches Fetch garantiert die Wahrheit.
        const currentMembers = new Set();
        try {
            const res = await fetch(VCS.Chat.API_BASE + '/groups/' + this._activeGroupId, {
                headers: VCS.chat?.authHeaders()
            });
            if (res.ok) {
                const data = await res.json();
                for (const m of (data.members || [])) {
                    if (m?.phone) currentMembers.add(m.phone);
                }
            }
        } catch (e) {
            console.error('[groups] fetch members for picker error:', e);
        }

        // DOM-Mitglieder als Fallback / Ergänzung.
        $('#groupMembersList')[0]?.querySelectorAll('[data-phone]').forEach(el => {
            if (el.dataset.phone) currentMembers.add(el.dataset.phone);
        });

        const available = contacts.filter(c => c.phoneNumber && !currentMembers.has(c.phoneNumber));

        if (available.length === 0) {
            picker.innerHTML = `<div class="text-muted small">${t('groupNoContacts')}</div>`;
            return;
        }

        let html = '';
        for (const c of available) {
            const name = c.displayName || c.phoneNumber;
            html += `<label class="group-contact-picker-item">
                <input type="checkbox" value="${this._esc(c.phoneNumber)}">
                <span>${this._esc(name)}</span>
            </label>`;
        }
        picker.innerHTML = html;
    }

    async addMembers() {
        if (!this._activeGroupId) return;
        const picker = $('#addMemberContactPicker')[0];
        const phones = [];
        picker?.querySelectorAll('input[type="checkbox"]:checked').forEach(cb => {
            phones.push(cb.value);
        });
        if (phones.length === 0) return;

        try {
            await fetch(VCS.Chat.API_BASE + '/groups/' + this._activeGroupId + '/members', {
                method: 'POST',
                headers: VCS.chat?.authHeaders({ 'Content-Type': 'application/json' }),
                body: JSON.stringify({ phones })
            });

            bootstrap.Modal.getInstance($('#addGroupMemberModal')[0])?.hide();
            VCS.ui?.showToast?.(t('groupInvitesSent'), 'success', 5000);
            await this.openGroupDetail(this._activeGroupId);
        } catch (e) {
            console.error('[groups] addMembers error:', e);
        }
    }

    async removeMember(groupId, phone) {
        const t = (k) => VCS.i18n?.t(k) || k;
        if (!await VCS.ui?.showConfirm?.(t('groupMemberRemoved') + ': ' + phone + '?')) return;

        try {
            await fetch(VCS.Chat.API_BASE + '/groups/' + groupId + '/members/' + encodeURIComponent(phone), {
                method: 'DELETE',
                headers: VCS.chat?.authHeaders()
            });
            await this.openGroupDetail(groupId);
        } catch (e) {
            console.error('[groups] removeMember error:', e);
        }
    }

    async leaveGroup() {
        if (!this._activeGroupId) return;
        const t = (k) => VCS.i18n?.t(k) || k;
        if (!await VCS.ui?.showConfirm?.(t('groupLeaveConfirm'))) return;

        try {
            await fetch(VCS.Chat.API_BASE + '/groups/' + this._activeGroupId + '/members/' + encodeURIComponent(VCS.state.chatMyPhone), {
                method: 'DELETE',
                headers: VCS.chat?.authHeaders()
            });
            this.closeGroupDetail();
            await this.loadGroups();
        } catch (e) {
            console.error('[groups] leaveGroup error:', e);
        }
    }

    async deleteGroup() {
        if (!this._activeGroupId) return;
        const t = (k) => VCS.i18n?.t(k) || k;
        if (!await VCS.ui?.showConfirm?.(t('groupDeleteConfirm'))) return;

        try {
            await fetch(VCS.Chat.API_BASE + '/groups/' + this._activeGroupId, {
                method: 'DELETE',
                headers: VCS.chat?.authHeaders()
            });
            this.closeGroupDetail();
            await this.loadGroups();
        } catch (e) {
            console.error('[groups] deleteGroup error:', e);
        }
    }

    async renameGroup() {
        if (!this._activeGroupId) return;
        const t = (k) => VCS.i18n?.t(k) || k;
        const newName = prompt(t('groupRename'), $('#groupDetailName')[0]?.textContent || '');
        if (!newName || !newName.trim()) return;

        try {
            await fetch(VCS.Chat.API_BASE + '/groups/' + this._activeGroupId, {
                method: 'PUT',
                headers: VCS.chat?.authHeaders({ 'Content-Type': 'application/json' }),
                body: JSON.stringify({ name: newName.trim() })
            });
            await this.openGroupDetail(this._activeGroupId);
            await this.loadGroups();
        } catch (e) {
            console.error('[groups] renameGroup error:', e);
        }
    }

    // ── Sub-Tab-Steuerung ───────────────────────────────────

    switchSubTab(tab) {
        VCS.state.chatContactsSubTab = tab;
        const bar = $('#contactsSubTabBar')[0];
        if (bar) {
            bar.querySelectorAll('.contacts-sub-tab').forEach(btn => {
                btn.classList.toggle('contacts-sub-tab--active', btn.dataset.subtab === tab);
            });
        }

        const contactsList = $('#contactsList')[0];
        const groupsTab = $('#groupsTab')[0];
        const btnNew = $('#btnNewContact')[0];

        if (tab === 'groups') {
            contactsList?.classList.add('hidden');
            groupsTab?.classList.remove('hidden');
            if (btnNew) btnNew.classList.add('hidden');
            this.loadGroups();
        } else {
            contactsList?.classList.remove('hidden');
            groupsTab?.classList.add('hidden');
            if (btnNew) btnNew.classList.remove('hidden');
            VCS.chatContacts?.loadContacts?.();
        }
    }

    // ── WebSocket-Handler ───────────────────────────────────

    handleGroupCreated(msg) {
        this.loadGroups();
    }

    handleGroupMemberAdded(msg) {
        this.loadGroups();
        if (this._activeGroupId === msg.groupId) {
            this.openGroupDetail(msg.groupId);
        }
    }

    handleGroupMemberRemoved(msg) {
        if (msg.phone === VCS.state.chatMyPhone) {
            if (this._activeGroupId === msg.groupId) {
                this.closeGroupDetail();
            }
        } else if (this._activeGroupId === msg.groupId) {
            this.openGroupDetail(msg.groupId);
        }
        this.loadGroups();
    }

    handleGroupUpdated(msg) {
        this.loadGroups();
        if (this._activeGroupId === msg.groupId) {
            this.openGroupDetail(msg.groupId);
        }
    }

    // ── Gruppeneinladungen (28.09.) ─────────────────────────
    //
    // Mitglied wird man erst nach Zustimmung. Der Server schickt offene
    // Einladungen nach jeder Anmeldung ('group-invites') und neue sofort
    // ('group-invite'). Je Einladung ein Dialog: Beitreten / Ablehnen / Spaeter.

    handleGroupInvites(msg) {
        for (const inv of (msg.invites || [])) this._queueInvite(inv);
    }

    handleGroupInvite(msg) {
        if (msg.invite) this._queueInvite(msg.invite);
    }

    // Zurueckgezogen, Gruppe geloescht oder auf einem anderen Geraet
    // beantwortet: aus der Warteschlange nehmen.
    handleGroupInviteCancelled(msg) {
        this._inviteQueue = this._inviteQueue.filter(i => i.groupId !== msg.groupId);
    }

    // Liste "eingeladen" eines offenen Detail-Screens aktualisieren.
    handleGroupInvitesUpdated(msg) {
        if (this._activeGroupId === msg.groupId) {
            this.openGroupDetail(msg.groupId);
        }
    }

    _queueInvite(inv) {
        if (!inv?.groupId || this._invitesLater.has(inv.groupId)) return;
        if (this._inviteQueue.some(i => i.groupId === inv.groupId)) return;
        this._inviteQueue.push(inv);
        this._showNextInvite();
    }

    async _showNextInvite() {
        if (this._inviteDialogOpen || this._inviteQueue.length === 0) return;
        const s = VCS.state;
        // Nicht mitten in einen Anruf -- danach erneut versuchen.
        if (s.directCallActive || s.groupCallActive) {
            setTimeout(() => this._showNextInvite(), 5000);
            return;
        }
        const inv = this._inviteQueue.shift();
        this._inviteDialogOpen = true;
        try {
            const text = t('groupInviteAsk')
                .replace('{name}', inv.invitedByName || inv.invitedBy || '?')
                .replace('{group}', inv.groupName || '?');
            const icon = '<svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg>';
            const choice = await VCS.ui?.showChoice?.(text, icon,
                t('groupInviteJoin'), t('groupInviteDecline'), t('groupInviteLater'));
            if (choice === 'yes') {
                await this._answerInvite(inv.groupId, 'accept');
            } else if (choice === 'no') {
                await this._answerInvite(inv.groupId, 'decline');
            } else {
                this._invitesLater.add(inv.groupId);
            }
        } finally {
            this._inviteDialogOpen = false;
            this._showNextInvite();
        }
    }

    async _answerInvite(groupId, action) {
        try {
            const res = await fetch(VCS.Chat.API_BASE + '/groups/' + encodeURIComponent(groupId) + '/invite/' + action, {
                method : 'POST',
                headers: VCS.chat?.authHeaders({ 'Content-Type': 'application/json' }),
                body   : '{}'
            });
            if (action === 'decline') return;
            if (res.ok) {
                VCS.ui?.showToast?.(t('groupInviteJoined'), 'success');
                await this.loadGroups();
                // Gruppe soll auch in der Chatliste stehen.
                VCS.chatSetup?.loadChats?.();
                return;
            }
            const err = (await res.json().catch(() => ({}))).error;
            VCS.ui?.showToast?.(t(err === 'group_full' ? 'groupInviteFull' : 'groupInviteGone'), 'error');
        } catch (e) {
            console.error('[groups] answer invite error:', e);
            VCS.ui?.showToast?.(t('groupInviteGone'), 'error');
        }
    }

    async withdrawInvite(groupId, phone) {
        if (!await VCS.ui?.showConfirm?.(t('groupInviteWithdrawAsk'))) return;
        try {
            await fetch(VCS.Chat.API_BASE + '/groups/' + encodeURIComponent(groupId) + '/invites/' + encodeURIComponent(phone), {
                method : 'DELETE',
                headers: VCS.chat?.authHeaders()
            });
            await this.openGroupDetail(groupId);
        } catch (e) {
            console.error('[groups] withdraw invite error:', e);
        }
    }

    handleGroupDeleted(msg) {
        if (this._activeGroupId === msg.groupId) {
            this.closeGroupDetail();
        }
        this.loadGroups();
    }

    // ── Gruppen-Avatar ──────────────────────────────────────

    async uploadGroupAvatar(file) {
        if (!this._activeGroupId) return;
        const compressed = await VCS.chatSetup?._compressAvatar(file);
        const formData = new FormData();
        formData.append('avatar', compressed || file, 'avatar.jpg');

        try {
            const res = await fetch(VCS.Chat.API_BASE + '/groups/' + this._activeGroupId + '/avatar', {
                method: 'POST',
                headers: VCS.chat?.authHeaders(),
                body: formData
            });
            const result = await res.json();
            if (result.ok && result.avatarHash) {
                VCS.ui?.showToast?.(VCS.i18n?.t('profilePhotoSaved') || 'Gespeichert', 'success');
                this.openGroupDetail(this._activeGroupId);
                this.loadGroups();
            } else {
                VCS.ui?.showToast?.(result.error || 'Upload fehlgeschlagen', 'error');
            }
        } catch (e) {
            console.error('[groups] uploadGroupAvatar error:', e);
        }
    }

    // ── Helpers ─────────────────────────────────────────────

    _esc(str) {
        if (!str) return '';
        return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    // ── Group Video Call ───────────────────────────────────

    // Gespraechszusammenfassung im Gruppen-Call (28.09.). Gefragt wird an
    // allen drei Einstiegen (Starten, Toast, Banner) NACH der Entscheidung
    // beizutreten und VOR dem Beitritt. Anders als im 1:1-Annahme-Overlay
    // (Ankreuzfeld) hier ein eigener Dialog: im Gruppen-Call wartet niemand
    // auf die eigene Antwort. Recht nur beim Besteller -- Gruppen-Calls sind
    // nie verschluesselt, also reicht callSummaryAvailable. Abgeschickt wird
    // der Wunsch erst nach group-call-joined (signaling.js).
    async _askGroupSummary() {
        const s = VCS.state;
        VCS.callControls?.resetSummary?.();
        if (!s.callSummaryAvailable) return;
        const wish = await VCS.ui?.showConfirm?.(
            t('callSummaryAskGroup'), VCS.chatContacts?._summaryIcon?.() || '', t('callSummaryYes'), t('callSummaryNo'));
        s.callSummaryWish = wish === true;
    }

    async startGroupCall(groupId) {
        const s = VCS.state;
        if (!s.chatMyPhone || !s.chatAuthToken) return;
        try {
            await VCS.media?.initPreview?.();
        } catch (e) {
            VCS.ui?.showToast?.(t('cameraAccessDenied'), 'error');
            return;
        }
        try {
            const res = await fetch(VCS.Chat.API_BASE + '/call/group', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'x-phone': s.chatMyPhone },
                body: JSON.stringify({ callerPhone: s.chatMyPhone, groupId, callerName: s.chatMyName }),
            });
            const data = await res.json();
            if (!data.ok) { VCS.ui?.showToast?.(data.error || 'Fehler', 'error'); return; }
            VCS.webrtc?.startGroupCall(data.callId, groupId);
        } catch (e) {
            VCS.ui?.showToast?.('Fehler: ' + e.message, 'error');
        }
    }

    showIncomingGroupCallToast(msg) {
        const s = VCS.state;
        if (s.groupCallActive) return; // Schon in einem Call
        const toastId = 'gcall-toast-' + msg.callId;
        if (document.getElementById(toastId)) return;

        const toast = document.createElement('div');
        toast.id = toastId;
        toast.className = 'incoming-call-toast';
        toast.innerHTML = `
            <div class="incoming-call-info">
                <div class="incoming-call-avatar">${escapeHtml((msg.groupName || '?').charAt(0).toUpperCase())}</div>
                <div>
                    <div class="incoming-call-name">${escapeHtml(msg.groupName)}</div>
                    <div class="incoming-call-type">${escapeHtml(msg.callerName)} — ${t('groupCall')}</div>
                </div>
            </div>
            <div class="incoming-call-actions">
                <button class="incoming-call-btn incoming-call-btn--decline">${t('decline')}</button>
                <button class="incoming-call-btn incoming-call-btn--accept">${t('groupCallJoin')}</button>
            </div>`;
        document.body.appendChild(toast);
        requestAnimationFrame(() => toast.classList.add('incoming-call-toast--visible'));

        const cleanup = () => { toast.classList.remove('incoming-call-toast--visible'); setTimeout(() => toast.remove(), 300); };
        const autoTimer = setTimeout(cleanup, 30000);

        toast.querySelector('.incoming-call-btn--decline').addEventListener('click', () => { clearTimeout(autoTimer); cleanup(); });
        toast.querySelector('.incoming-call-btn--accept').addEventListener('click', async () => {
            clearTimeout(autoTimer);
            cleanup();
            await this._askGroupSummary();
            try { await VCS.media?.initPreview?.(); } catch (_) {}
            VCS.webrtc?.startGroupCall(msg.callId, msg.groupId);
        });
    }

    showGroupCallBanner(callId, groupId) {
        const banner = $('#groupCallBanner')[0];
        if (!banner) return;
        if (VCS.state.chatActiveChatId === groupId || VCS.state.chatActiveIsGroup) {
            banner.classList.remove('hidden');
            banner.dataset.callId = callId;
            banner.dataset.groupId = groupId;
        }
    }

    hideGroupCallBanner(groupId) {
        const banner = $('#groupCallBanner')[0];
        if (banner) banner.classList.add('hidden');
    }

    // ── Init ────────────────────────────────────────────────

    init() {
        // Sub-Tab-Klicks
        $('#contactsSubTabBar')[0]?.querySelectorAll('.contacts-sub-tab').forEach(btn => {
            btn.addEventListener('click', () => this.switchSubTab(btn.dataset.subtab));
        });

        // Inline "Neue Gruppe"-Button
        $('#btnCreateGroupInline')[0]?.addEventListener('click', () => this.showCreateGroupModal());

        // Gruppe erstellen (Modal-Bestätigung)
        $('#btnCreateGroup')[0]?.addEventListener('click', () => this.createGroup());

        // Gruppen-Detail: Zurück
        $('#btnGroupDetailBack')[0]?.addEventListener('click', () => this.closeGroupDetail());

        // Gruppen-Avatar Upload
        $('#groupDetailAvatarWrap')[0]?.addEventListener('click', () => {
            if ($('#groupDetailAvatarEdit')[0]?.classList.contains('hidden')) return;
            $('#groupAvatarInput')[0]?.click();
        });
        $('#groupAvatarInput')[0]?.addEventListener('change', (e) => {
            const file = e.target.files?.[0];
            if (file) this.uploadGroupAvatar(file);
            e.target.value = '';
        });

        // Gruppen-Detail: Mitglied hinzufügen
        $('#btnGroupAddMember')[0]?.addEventListener('click', () => this.showAddMemberModal());
        $('#btnAddGroupMembers')[0]?.addEventListener('click', () => this.addMembers());

        // Gruppen-Detail: Aktionen
        $('#btnGroupLeave')[0]?.addEventListener('click', () => this.leaveGroup());
        $('#btnGroupDelete')[0]?.addEventListener('click', () => this.deleteGroup());
        $('#btnGroupRename')[0]?.addEventListener('click', () => this.renameGroup());

        // Group Video Call Button
        $('#chatGroupCallBtn')[0]?.addEventListener('click', async () => {
            const groupId = VCS.state.chatActiveChatId;
            if (!groupId || !VCS.state.chatActiveIsGroup) return;
            const name = $('#chatDetailPeerName')[0]?.textContent || '?';
            const iconSvg = '<svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.8"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg>';
            const ok = await VCS.ui?.showConfirm?.(t('groupCallStart') + ' — ' + name, iconSvg);
            if (!ok) return;
            await this._askGroupSummary();
            this.startGroupCall(groupId);
        });

        // Join Group Call Banner
        $('#btnJoinGroupCall')[0]?.addEventListener('click', async () => {
            const banner = $('#groupCallBanner')[0];
            if (!banner) return;
            const callId = banner.dataset.callId;
            const groupId = banner.dataset.groupId;
            if (!callId || !groupId) return;
            await this._askGroupSummary();
            try { await VCS.media?.initPreview?.(); } catch (_) {}
            VCS.webrtc?.startGroupCall(callId, groupId);
        });
    }
};
